import type { LoaderFunction } from "@remix-run/node";
import { json } from "@remix-run/node";

import { withCors } from "~/config/cors";
import { PRODUCT_NAME } from "~/lib/env.shared";
import { pageMeta } from "~/utils/meta";
import BAA from "~/pages/BAA";

export const meta = pageMeta(
    `Business Associate Agreement - ${PRODUCT_NAME}`,
    `${PRODUCT_NAME} Business Associate Agreement`,
);

export const loader: LoaderFunction = withCors(async ({ request }) => json({}));

export default function BAARoute() {
    return <BAA />;
}
